import { Image } from "@frontend/core";
import { HubMicro } from "../hubs/hub-micro.model";
import { BrandColour } from "./brand-colour.model";

export type BrandLogoRole = 'logo_banner' | 'logo_banner_inverse' | 'logo_square' | 'logo_square_inverse';

export const BRAND_LOGO_ROLES : BrandLogoRole[] = ['logo_banner','logo_banner_inverse','logo_square','logo_square_inverse'];

export interface BrandLogos { // the backend sends logos role-keyed, under 'images' and 'pending_images'
    logo_banner?: Image,
    logo_banner_inverse?: Image,
    logo_square?: Image,
    logo_square_inverse?: Image
}

export interface UnsavedLogoChange { // a logo the user has chosen or deleted, before it reaches the backend
    file?: File,
    file_url?: string,
    removeSaved?: boolean
}

export interface UnsavedPendingChanges { // held locally in browser memory or localstorage and sent to the backend
    logo_banner?: UnsavedLogoChange,
    logo_banner_inverse?: UnsavedLogoChange,
    logo_square?: UnsavedLogoChange,
    logo_square_inverse?: UnsavedLogoChange,
}
export type SavedPendingChanges = BrandLogos; // received from the backend: uploaded for preview, not yet saved

export class Brand {

    constructor (
        public id : number,
        public name: string, // "Training Company 1",
        public slug: string, // "tco1",
        public colours: BrandColour[], // [{\"name': \"primary-dark\", \"hex\": \"#FF00FF\"}]",
        public font: string, // "serif" or "sans-serif",
        public slogan: string, // "Catch the train to successville",
        public pending: SavedPendingChanges,
        public logo_square: Image,
        public logo_banner: Image,
        public logo_square_inverse: Image,
        public logo_banner_inverse: Image,
        public created_at: string, // "2021-06-14 07:18:55",
        public updated_at: string, // "2021-06-14 07:18:55",
        public deleted_at: string, // null,
        public loaded_at: Date, // the last time we got this from the server
        public hubMicro?: HubMicro,
        public pending_updates?: UnsavedPendingChanges,
        public completion?: number,
        public category?: string,
    ){
        this.id = id;
        this.name = name;
        this.slug = slug;
        this.colours = colours;
        this.font = font;
        this.slogan = slogan;
        this.pending = pending;
        this.logo_square = logo_square;
        this.logo_square_inverse = logo_square_inverse;
        this.logo_banner = logo_banner;
        this.logo_banner_inverse = logo_banner_inverse;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.loaded_at = loaded_at;
        this.hubMicro = hubMicro;
        this.pending_updates = pending_updates;
        this.completion = completion;
        this.category = category;
    }
}